import React, { useCallback, useMemo, useState } from 'react';
import { Form } from 'semantic-ui-react';
import { Link, useHistory } from 'react-router-dom';
import { withAuthLayout } from 'layouts/AuthLayout/AuthLayout';
import { forgotPassword } from 'services/auth.service';
import { useAlert } from 'context/AlertProvider';
import useInput from 'hooks/useInput';

function ForgotPasswordPage(props) {
  const alert = useAlert();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useInput();

  const errorTranslations = useMemo(
    () => ({
      'Username/client id combination not found.': 'Usuario no encontrado',
    }),
    [],
  );

  const submitHandler = useCallback(
    async (username) => {
      try {
        setLoading(true);
        await forgotPassword(username);
        alert.current.message(
          `El código de confirmación para la recuperación de la contraseña se ha enviado al correo del usuario <strong>${username}</strong>`,
          () => history.push('/reset-password'),
        );
      } catch (error) {
        console.error(error);
        if (error.message) {
          alert.current.error(
            errorTranslations[error.message] ?? 'Error recuperando el usuario',
          );
        } else {
          alert.current.error('Error recuperando el usuario');
        }
        setLoading(false);
      }
    },
    [history, alert, errorTranslations],
  );

  return (
    <>
      <h1>Restablecer contraseña</h1>
      <Form>
        <Form.Input
          required
          value={username}
          onChange={setUsername}
          className="username"
          label="E-mail"
          autoComplete="new-password"
        />
        <Form.Button
          className="login-button"
          primary
          fluid
          type="submit"
          disabled={!username || loading}
          loading={loading}
          onClick={(event, data) => submitHandler(username)}
        >
          Recuperar contraseña
        </Form.Button>
      </Form>
      <footer className="auth-layout__footer">
        <Link to="/login">Volver</Link>
      </footer>
    </>
  );
}

export default withAuthLayout(ForgotPasswordPage);
